export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10014.906e1ccc.jpg";